import { AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { Calendar } from 'primeng/calendar';
import Swal from 'sweetalert2';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { SchedularLogService } from 'src/app/views/main-layout/schedularlog/schedularLog.service';
import { window } from 'rxjs';

@Component({
  selector: 'app-schedulelogfilters',
  templateUrl: './schedulelogfilters.component.html',
  styleUrls: ['./schedulelogfilters.component.css']
})
export class SchedulelogfiltersComponent implements OnInit {
  minDateValue: Date;
  onclear(event) {
    if (event.to_date == null || event.from_date == null) {
      this.errorDIsplay = false;
      this.filtersData['from_date'] = ''; this.filtersData['to_date'] = '';
      this.schedularlogService.getFilterChange(this.filtersData)
    }
  }
  ref: DynamicDialogRef;
  index_value: any;
  productList: any[];
  schedulerList: any[];
  statusList: any[];
  typeList: any[];
  schedule: any;
  product: any;
  todateerrorDIsplay = false;
  fromdateerrorDisplay = false;


  @ViewChild('dropdown') dropdown: Dropdown;
  @ViewChild('p-calendar') calendar: Calendar;

  maxLabelWidth: number;
  filterinput: Filterreq = new Filterreq();
  filtersData: Filterreq = new Filterreq();
  @Output() dataEvent = new EventEmitter<{}>();
  formArr: any;
  todaysDate: Date = new Date();
  ngOnInit() {
    // // document.getElementById("from_date").value = "2014-02-09";
    this.filterinput.from_date = moment(this.todaysDate).format('DD-MMM-YYYY');
    this.filterinput.to_date = moment(this.todaysDate).format('DD-MMM-YYYY');
    this.schedularlogService.getFilterChange(this.filterinput);
    this.validateDates();
  }

  @Input() componentname: string = "";

  errorDIsplay = false;
  isround: boolean = true
  filtresParams = [];
  SchedulerForm: FormGroup;
  constructor(private schedularlogService: SchedularLogService
  ) {
    this.getDropdownList();
    this.schedularlogService.getFilterChange(this.filtersData);

  }


  getDropdownList() {
    const product_list = this.schedularlogService.get_product(this.filtersData);
    product_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.productname.localeCompare(b.productname);
      });
      this.productList = res.map(e => ({ labelname: e.productname, value: e.productid }));
      this.productList.unshift({ labelname: 'Select', value: "" })
    });
    const scheduler_list = this.schedularlogService.get_schedular(this.filtersData);
    scheduler_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.schedulername.localeCompare(b.schedulername);
      });
      this.schedulerList = res.map(e => ({ labelname: e.schedulername, value: e.schedulername }));
      this.schedulerList.unshift({ labelname: 'Select', value: "" })
    });
    const type_list = this.schedularlogService.get_type(this.filtersData);
    type_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.schedulertype.localeCompare(b.schedulertype);
      });
      this.typeList = res.map(e => ({ labelname: e.schedulertype, value: e.schedulertype }));
      this.typeList.unshift({ labelname: 'Select', value: "" })
    });
    const status_list = this.schedularlogService.get_status(this.filtersData);
    status_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.statusname.localeCompare(b.statusname);
      });
      this.statusList = res.map(e => ({ labelname: e.statusname, value: e.status }));
      this.statusList.unshift({ labelname: 'Select', value: "" })
    });

  }

  onFilterSelect(event) {
    Object.keys(this.filterinput).forEach(key => {
      if (this.filterinput[key] === undefined || this.filterinput[key] === null) {
        this.filterinput[key] = '';
      }
    });
    this.filtersData = event;
    this.schedularlogService.getFilterChange(this.filtersData);
    this.getDropdownList();
  }

  getproductTooltip(): string {
    const selectedId = this.filterinput.productid;
    if (!selectedId) {
      return 'Select Product';
    }
    const selected = this.productList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Product';
  }

  getschedulerTooltip(): string {
    const selectedId = this.filterinput.schedulerid;
    if (!selectedId) {
      return 'Select Scheduler';
    }
    const selected = this.schedulerList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Scheduler';
  }

  getstatusTooltip(): string {
    const selectedId = this.filterinput.status;
    if (!selectedId) {
      return 'Select Status';
    }
    const selected = this.statusList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Status';
  }

  gettypeTooltip(): string {
    const selectedId = this.filterinput.schedulertype;
    if (!selectedId) {
      return 'Select Scheduler Type';
    }
    const selected = this.typeList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Scheduler Type';
  }

  getdates(event) {
    if (event.from_date !== "" && event.to_date !== "") {
      this.filtersData.from_date = moment(event.from_date).format('DD-MMM-YYYY');
      this.filtersData.to_date = moment(event.to_date).format('DD-MMM-YYYY');
      this.schedularlogService.getFilterChange(this.filtersData);
    }
    this.validateDates();
  }

  validateDates() {

    this.fromdateerrorDisplay = false;
    this.todateerrorDIsplay = false;
    this.errorDIsplay = false;

    const fromDate = this.filterinput.from_date;
    const toDate = this.filterinput.to_date;

    if (!fromDate) {
      this.fromdateerrorDisplay = true;
      return;
    }

    if (!toDate) {
      this.todateerrorDIsplay = true;
      return;
    }

    if (moment(fromDate).isAfter(moment(toDate))) {
      this.errorDIsplay = true;
      return;
    }
  }

refreshFilters() {
  this.errorDIsplay = false;

  this.filterinput = new Filterreq();
  this.filtersData = new Filterreq();

  // Set values to the object bound to UI
  this.filterinput.from_date = moment(this.todaysDate).format('DD-MMM-YYYY');
  this.filterinput.to_date = moment(this.todaysDate).format('DD-MMM-YYYY');

  // If backend needs formatted values
  this.filtersData['from_date'] = moment(this.todaysDate).format('DD-MMM-YYYY');
  this.filtersData['to_date'] = moment(this.todaysDate).format('DD-MMM-YYYY');

  this.filtersData['page'] = 1;
  this.filtersData['size'] = 10;

  this.getDropdownList();
  this.schedularlogService.getFilterChange(this.filtersData);
  this.schedularlogService.filterrefresh();
}
}

export class Filterreq {
  productid = "";
  schedulerid = "";
  schedulertype = "";
  status = "";
  from_date: any = '';
  to_date: any = '';
  page = 1;
  size = 10;
}


